import { useContext } from 'react';
import { Context } from './Context';
export const useWorkflowCheck = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useWorkflowCheck hook used outside <WorkflowCheckProvider />');
    }
    return context;
};
